(() => {
  if (window.__lyneciaLinkedMotifCart) return;
  window.__lyneciaLinkedMotifCart = true;

  const addonHandle = 'lynecia-supplement-motif-broderie';
  const normalize = (value) => String(value || '').trim().toLocaleLowerCase('fr-FR');
  const motifName = (value) => String(value || '').replace(/\s*\([^)]*\)\s*$/, '').trim();

  document.addEventListener('click', async (event) => {
    const removeControl = event.target.closest('cart-remove-button a, cart-remove-button button.cart-remove-button');
    if (!removeControl) return;

    const wrapper = removeControl.closest('cart-remove-button');
    const line = Number(wrapper?.dataset.index);
    if (!Number.isInteger(line) || line < 1) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (removeControl.dataset.lyneciaRemoving === 'true') return;
    removeControl.dataset.lyneciaRemoving = 'true';
    removeControl.setAttribute('aria-disabled', 'true');

    try {
      const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      if (!cartResponse.ok) throw new Error('Impossible de lire le panier');
      const cart = await cartResponse.json();
      const item = cart.items[line - 1];
      if (!item) throw new Error('Ligne du panier introuvable');

      const updates = {};
      updates[item.key] = 0;

      if (item.handle !== addonHandle) {
        const parentTitle = normalize(item.product_title);
        const parentMotif = normalize(motifName(item.properties?.['Motif de broderie']));
        const candidates = cart.items.filter(candidate =>
          candidate.handle === addonHandle &&
          normalize(candidate.properties?.['Produit associé']) === parentTitle
        );
        let matching = [];
        if (parentMotif) {
          matching = candidates.filter(candidate =>
            normalize(candidate.properties?.['Motif associé']) === parentMotif
          );
        }
        if (!matching.length && candidates.length === 1) matching = candidates;
        matching.forEach(candidate => { updates[candidate.key] = 0; });
      }

      const updateResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates })
      });
      if (!updateResponse.ok) throw new Error('Impossible de mettre à jour le panier');
      window.location.reload();
    } catch (error) {
      console.error('[Lynecia] Suppression du produit et de son supplément impossible :', error);
      window.location.reload();
    }
  }, true);
})();